export default {
    // Sidebar
    'Nova OS Proativa':  'Nova OS Proativa',
    'Interno':  'Interno',
    'Externo':  "Externo",
    'Preventiva':  "Preventiva",
    'Preventiva Programada':  "Preventiva Programada",
    "Preventiva Programada Armazém": "Preventiva Programada Armazém",
    'Reaberta':  "Reaberta",
    'Execuções':  "Execuções",
    'Armazém':  "Armazém",
    'Frota':  "Frota",
    'Sair':  "Sair",
    'Inventário':  "Inventário",

    // Nova Os
    'Voltar':  "Voltar",
    'Nova OS':  "Nova OS",
    'Operação':  "Operação",
    'Placa':  "Placa",
    'Segmento':  "Segmento",
    'Problemas':  "Problemas",
    'Descrição do Problema':  "Descrição do Problema",
    'Gerar OS':  "Gerar OS",
    'Cancelar':  "Cancelar",

    // OS Interna
    "Nenhum resultado encontrado": "Nenhum resultado encontrado",
    "Exibindo resultado": "Exibindo resultado",
    "de": "de",
    "Aberta há": "Aberta há",
    "Concluída em": "Concluída em",

    // Ordem Servico
    "Detalhes": "Detalhes",
    "Mostrar": "Mostrar",
    "Esconder": "Esconder",
    "Telefone": "Telefone",
    "Data": "Data",
    "Início": "Início",
    "Final": "Final",
    "Fornecedor": "Fornecedor",
    "Tipo": "Tipo",
    "Ciclo preventiva": "Ciclo preventiva",
    "Criticidade": "Criticidade",
    "Previsão de Atendimento": "Previsão de Atendimento",
    "Atendimento do Item": "Atendimento do Item",
    "Observações": "Observações",
    "Imagens": "Imagens",
    "Salvar": "Salvar",
    "Ordens de Serviço": "Ordens de Serviço",
    "GERADA_CHECKLIST": "GERADA A PARTIR DO CHECKLIST",
    "OBS_CHECKLIST": "OBSERVAÇÕES DO CHECKLIST:",
    "OS_INTERNA": "OS INTERNA:",

    // OS Item
    "Iniciar": "Iniciar",
    "Ações": "Ações",
    "Continuar": "Continuar",
    "Pausar": "Pausar",
    "Registrar Peças": "Registrar Peças",
    "Cancelar OS": "Cancelar OS",
    "OS Externa": "OS Externa",
    "Insira um serviço. Tente novamente.": "Insira um serviço. Tente novamente.",
    "Falha ao carregar os dados da OS": "Falha ao carregar os dados da OS",
    "Falha ao carregar os itens da OS": "Falha ao carregar os itens da OS",

    // ModalItems
    "Serviços": "Serviços",
    "SERVIÇOS": "SERVIÇOS",
    "Observação": "Observação",
    "Anexo de arquivos": "Anexo de arquivos",
    "Informe o valor total dos serviços/peças": "Informe o valor total dos serviços/peças",
    "Informe o motivo do socorro em rota": "Informe o motivo do socorro em rota",
    "Informe o pneu utilizado neste serviço": "Informe o pneu utilizado neste serviço",
    "Foi trocado o pneu": "Foi trocado o pneu",
    "Finalizar OS": "Finalizar OS",

    // Modal se foi utilizado peças
    "Foi utilizado Peças?": "Foi utilizado Peças?",
    "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!": "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!",
    "Não": "Não",
    "Sim": "Sim",

    // Modal Itens Fim
    "Informe os itens utilizados neste serviço": "Informe os itens utilizados neste serviço",
    "Fechar": "Fechar",
    "Peças": "Peças",
    "Peça": "Peça",
    "Quantidade": "Quantidade",
    "Preço": "Preço",
    "Informe o pneu novo": "Informe o pneu novo",
    
    //Modal Pause
    "Informe a Justificativa": "Informe a Justificativa",
    "Confirmar Pausa": "Confirmar Pausa",
    "Justificativa": 'Justificativa',
    "Ir ao banheiro": 'Ir ao banheiro',
    "Fim de expediente": 'Fim de expediente',
    "Atendimento": 'Atendimento',
    "Refeição": 'Refeição',
    "Aguardando Peças": 'Aguardando Peças',
    "Auxílio externo": 'Auxílio externo',
    'Selecione qual peça está aguardando': 'Selecione qual peça está aguardando',

    // Confirmar OS Externa
    "Confirmar OS Externa": "Confirmar OS Externa",
    "Deseja realmente enviar OS": "Deseja realmente enviar OS",
    "Confirmar": "Confirmar",

    // Lista de Execucao
    "Lista de execução": "Lista de execução",
    "Nenhuma execução ativa": "Nenhuma execução ativa",
    "Início Atendimento": "Início Atendimento",
    "Encerrar OS": "Encerrar OS",
    "Acessar OS": "Acessar OS",
    "Colaborador": "Colaborador",
    "Execuções em Pause": "Execuções em Pause",
    "Nenhuma execução em pause": "Nenhuma execução em pause",

    // Login
    "Torne sua rotina mais dinâmica": "Torne sua rotina mais dinâmica",
    "ACESSO AO SISTEMA": "ACESSO AO SISTEMA",
    "Terminal Oficina": "Terminal Oficina",
    "Realize o login e tenha acesso ao controle": "Realize o login e tenha acesso ao controle",
    "e gestão de suas Ordens de Serviço": "e gestão de suas Ordens de Serviço",
    "Mecânico Externo": "Mecânico Externo",
    "Acessar": "Acessar",
    "Falha ao fazer login": "Falha ao fazer login",

    // Filtro Internas
    "Ordenar": "Ordenar",
    "Antigas Primeiro": "Antigas Primeiro",
    "Recentes Primeiro": "Recentes Primeiro",
    "Maior": "Maior",
    "Menor": "Menor",
    "Segmentos": "Segmentos",
    "Período": "Período",
    "Execução": "Execução",
    "Todos": "Todos",
    "Pendentes": "Pendentes",
    "Finalizadas": "Finalizadas",
    "Aplicar filtro": "Aplicar filtro",
    "Limpar filtros": "Limpar filtros",
    "Esconder filtros": "Esconder filtros",
    "Criado por": "Criado por",
    "Usuário": "Usuário",

    // Os Preventivas
    "Filtre as OS Preventivas": "Filtre as OS Preventivas",
    "Preventivas Vencidas": "Preventivas Vencidas",
    "Preventivas à Vencer": "Preventivas à Vencer",
    "Carrocerias Vencidas": "Carrocerias Vencidas",
    "Atualizar": "Atualizar",

    // Modais Preventivas
    "ACAO": "ACAO",
    "PLACA": "PLACA",
    "PROXIMO_CICLO": "PROXIMO_CICLO",
    "VENCIMENTO": "VENCIMENTO",
    "PROXIMO_KM": "PROXIMO_KM",
    "KM_ATUAL": "KM_ATUAL",
    "Vincular Fornecedor": "Vincular Fornecedor",

    // Inventário
    "Não contados": "Não contados",
    "Contados": "Contados",
    "Ordenação": "Ordenação",
    "Total Itens": "Total Itens",
    "Inventário de Estoque": "Inventário de Estoque",
    "Inventário criado com sucesso!": "Inventário criado com sucesso!",
    "Já existe um inventário em execução": "Já existe um inventário em execução",
    "Deseja iniciar um novo inventário?": "Deseja iniciar um novo inventário?",

    // Modal Mecanico
    "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade": "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade",
    'Confirmar identidade': 'Confirmar identidade',

    "Erro do Motorista": "Erro do Motorista",
    "Defeito não Encontrado": "Defeito não Encontrado",

    "Informe o serviço": "Informe o serviço",
    "Insira os Itens": "Insira os Itens",

    "Alterar Fornecedor": "Alterar Fornecedor",
    "Preventivas Armazém": "Preventivas Armazém",
    "Outros": "Outros",
    "Ver Encerradas": "Ver Encerradas",
    "Tem dúvida?": "Tem dúvida?",
    "Nenhuma OS aguardando aprovação": "Nenhuma OS aguardando aprovação",
    "Aguardando Aprovação": "Aguardando Aprovação",

    "OS Preventivas Vencidas": "OS Preventivas Vencidas",
    "OS Encerradas - Últimas 15 OS": "OS Encerradas - Últimas 15 OS",
    "DATA": 'DATA',

    'Precisa de Ajuda?': 'Precisa de Ajuda?',
    'Desejamos um ótimo 2024!': 'Desejamos um ótimo 2024!',
    
    'Bem vindo(a) ao Terminal da Borracharia!': 'Bem vindo(a) ao Terminal da Borracharia!',
    'Realize a gestão de pneus pelo novo terminal da borracharia!': 'Realize a gestão de pneus pelo novo terminal da borracharia!',
    'Aderência Aferição 01': 'Aderência Aferição',
    'Aderência Aferição 02': 'Aderência Aferição',
    'de Calibragem': 'de Calibragem',
    'Aferição': 'Aferição',
    'Movimentação/Troca': 'Movimentação/Troca',
    'Descarte': 'Descarte',
    'Serviço': 'Serviço',
    'Borracharia': 'Borracharia',
    'Placas': 'Placas',

    'AÇÃO': 'AÇÃO',
    'TIPO': 'TIPO',
    'CONJUNTO': 'CONJUNTO',
    'AFERIÇÃO': 'AFERIÇÃO',

    'Selecione um Pneu': 'Selecione um Pneu',
    'Informar KM': 'Informar KM',
    'Informar Aferição': 'Informar Aferição',
    'Aferindo NR Fogo': 'Aferindo NR Fogo',
    'Última Aferição': 'Última Aferição',
    'Novas Aferições': 'Novas Aferições',
    'Última aferição NR fogo': 'Última aferição NR fogo',
    'Registrar Aferições': 'Registrar Aferições',
    'Realizar avaliação': 'Realizar avaliação',
    'Preditiva': 'Preditiva',
    'Externas Armazém': 'Externas Armazém',
    'Carrocerias à Vencer': 'Carrocerias à Vencer',
    
    'Problema': 'Problema',
    'Pendente': 'Pendente',
    'Descartes': 'Descartes',
    
    'OS Preditiva': 'OS Preditiva',
    'Gerar OS Preditiva': 'Gerar OS Preditiva',
    'Iniciar novo inventário': 'Iniciar novo inventário',
    'Dt Inicial': 'Dt Inicial',
    'Dt Final': 'Dt Final',

    "Fora do Prazo": "Fora do Prazo",
    "Dentro do Prazo": "Dentro do Prazo",

    "CALIBRAGEM": "CALIBRAGEM",
    "Nunca feito": "Nunca feito",
    "FOGO": "FOGO",
    "Informar Calibragem": "Informar Calibragem",
    "Comece a digitar o nome do fornecedor para exibir na lista abaixo": "Comece a digitar o nome do fornecedor para exibir na lista abaixo",

    "Portugues": "Português",
    "Mercosul": "Mercosul",
    "Ingles": "Inglês",
    'Frances': "Francês",
    'Alemao': 'Alemão',
    'Holandes': 'Holandês',
    'Espanhol': 'Espanhol',

    "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA",
    "CODIGO OS": "CÓDIGO OS",
    "TODOS": "TODOS",
    "Socorro em Rota pendente de atendimento": "Socorro em rota pendente de atendimento",
    "FILTROS": "FILTROS",
    "Salvar Filtro": "Salvar filtro",
    "Motorista": "Motorista",
    "Orçamento": "Orçamento",
    "Confirmar Orçamento": "Confirmar orçamento",
    "Deseja pausar esta OS para aguardar o orçamento?": "Deseja pausar esta OS para aguardar o orçamento?",
    "Valor": "Valor",
    "Pausar OS": "Pausar OS",
    "Comentarios": "Comentários",
    "Insira um comentário": "Insira um comentário",
    "Enviar OS": "Enviar OS",
    "Selecione uma justificativa": "Selecione uma justificativa",
    "Anexos": "Anexos",
    "OS Socorro em Rotas": "OS Socorro em Rotas",
    "Confirmar Cancelamento": "Confirmar cancelamento",
    "Buscar Placa": "Buscar placa",
    "Pesquisa de OS por placa": "Pesquisa de OS por placa",

    "Ordem gerada com sucesso": "Ordem gerada com sucesso",
    "Sucesso": "Sucesso",
    "Selecionar Todos": "Selecionar todos",
    "Descrição": "Descrição",
    "Registrar Serviços": "Registrar serviços",
    "Visualizar Itens": "Visualizar itens",
    "Clique no botão a direita para registrar as peças": "Clique no botão à direita para registrar as peças",

    "Selecionar técnico": "Selecionar técnico",
    "KM atual/Horimetro": "KM atual / Horímetro",
    "Deseja inserir alguma imagem no atendimento": "Deseja inserir alguma imagem no atendimento?",
    "Para concluir a ação, selecione abaixo o técnico responsável": "Para concluir a ação, selecione abaixo o técnico responsável",
    "Trabalhando": "Trabalhando",
    "Matricula": "Matrícula",
    "Serviços registrado com sucesso": "Serviços registrados com sucesso",
    "Função": "Função",
    "Enviar Anexos": "Enviar anexos",
    "Gerar Preventiva Programada": "Gerar preventiva programada",
    "OS Preventiva Programada": "OS preventiva programada",
    "Finalize todas as peças e serviços para encerrar o atendimento": "Finalize todas as peças e serviços para encerrar o atendimento",
    "Insira um KM maior que o anterior": "Insira um KM maior que o anterior",
    "Insira um KM maior que o atual": "Insira um KM maior que o atual",
    "Inserir anexos": "Inserir anexos",
    "Planos Preventivos": "Planos preventivos",
    "Filtro": "Filtro",
    "ULTIMA": "ÚLTIMA",
    "Gerar Preditiva": "Gerar preditiva",
    "Carregando": "Carregando",
    "OS Preventiva Programada Armazém": "OS preventiva programada – Armazém",
    "Gerar OS Preventiva Programada": "Gerar OS preventiva programada",
    "OS Preventivas à Vencer": "OS preventivas a vencer",
    "OS de Transição": "OS de Transição",

    
    "IMEDIATA": "IMEDIATA",
    "EMERGENCIAL": "EMERGENCIAL",
    "ALTA": "ALTA",
    "MÉDIA": "MÉDIA",
    "LEVE": "MÉDIA",

    "Registrar Tarefas": "Registrar Tarefas",
    "Desbloqueia Empilhadeira": "Desbloqueia Empilhadeira",
    "OS Ag. Aprovação": "OS Ag. Aprovação",
    "OS Internas Veículos": "OS Internas Veículos",
    "OS Internas Armazém": "OS Internas Armazém",
    "OS Reabertas": "OS Reabertas",
    "Criticidade de OS Abertas": "Criticidade de OS Abertas",
    "Top 20 Placas com mais OS": "Top 20 Placas com mais OS",
    "Qtd OS": "Qtd OS",

    // Dashboard
    "Criticidade de OS abertas": "Criticidade de OS abertas",
    "URGENTE": "URGENTE",
    "PREVENTIVA": "PREVENTIVA",
    "CRITICIDADES": "CRITICIDADES",
    "Bem Vindo(a)": "Bem Vindo(a)",
    "Tenha acesso as principais": "Tenha acesso as principais",
    "informações da sua mecânica!": "informações da sua mecânica!",
    "Ver OS internas": "Ver OS internas",
    "OS TicketLog": "OS TicketLog",
    "OS Externas": "OS Externas",
    "OS Interna Veículos": "OS Interna Veículos",
    "OS Interna Armazém": "OS Interna Armazém",
    "Ranking dos Mecânicos": "Ranking dos Mecânicos",
    "Tipo de OS": "Tipo de OS",
    "Atendidas nos últimos 30 dias": "Atendidas nos últimos 30 dias",
    "TOP 20 Placas com mais OS": "TOP 20 Placas com mais OS",
    "Últimos 30 dias": "Últimos 30 dias",
    "Placas com OS Externas": "Placas com OS Externas",
    "TOP 10 Problemas mais atendidos": "TOP 10 Problemas mais atendidos",
    "Nos últimos 30 dias": "Nos últimos 30 dias",
    "Status por Mecânico": "Status por Mecânico",
    "Produtividade": "Produtividade",

    // ModalEncerradas
    "Filtros": "Filtros",
    "NÚMERO": "NÚMERO",
    "INÍCIO": "INÍCIO",
    "FINAL": "FINAL",
    "SEGMENTO": "SEGMENTO",
    "PROBLEMA": "PROBLEMA",

    // Login
    "Acesso Rápido": "Acesso Rápido",
    "ID": "CPF",
    "CNPJ": "CNPJ",
    "codigo_fornec": "ID",
    "Para qual fornecedor você deseja enviar esta OS": "Para qual fornecedor você deseja enviar esta OS",

    'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!': 'Se foi utilizado peças neste atendimento, pressione "Sim" na opção abaixo!',
    "FILTRO EMPRESA": "FILTRO EMPRESA",
    "Upload Arquivos": "Upload Arquivos",
    "Cards": "Cards",
    "Colunas": "Colunas",
    "ULTIMA MM": "ULTIMA MM",
    "PRÓXIMA MM": "PRÓXIMA MM",
    "ULTIMA CAL": "ULTIMA CAL",
    "PRÓXIMA CAL": "PRÓXIMA CAL",

    "ULTIMA MOVIMENTACAO": "ULTIMA MOVIMENTAÇÃO",
    "PRÓXIMA MOVIMENTACAO": "PRÓXIMA MOVIMENTAÇÃO",
    "N° FOGO": "N° FOGO",
    "FILIAL": "FILIAL",
    "MARCA": "MARCA",
    "MEDIDA": "MEDIDA",

    "Aguardando Aprovação de Sinistro": "Aguardando Aprovação de Sinistro",
    "Aguardando Liberacao": "Aguardando Liberacao",
    "Nenhuma OS aguardando liberacao": "Nenhuma OS aguardando liberacao",
    "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão": 
    "O tempo total é inferior a 5 minutos. Isso poderá impactar negativamente no controle de gestão",

    "Aguardar Liberação": "Aguardar Liberação",
    "CONTRATO_CONCESSIONARIA": "CONTRATO CONCESSIONARIA",

    // Chaves adicionadas para i18n completo
    "Adicionar Serviços": "Adicionar Serviços",
    "Ação": "Ação",
    "CD_PNEU": "CD_PNEU",
    "CPF (3 primeiros digitos)": "CPF (3 primeiros dígitos)",
    "Cadastro": "Cadastro",
    "Calibragem NR Fogo": "Calibragem NR Fogo",
    "Confirmar envio Ticket": "Confirmar envio Ticket",
    "Conserto de Pneus": "Conserto de Pneus",
    "DS_PREDITIVO": "DESCRIÇÃO PREDITIVA",
    "DashBoard": "Dashboard",
    "Dashboard": "Dashboard",
    "Data Final": "Data Final",
    "Data Inicial": "Data Inicial",
    "Data OS": "Data OS",
    "Descartar": "Descartar",
    "Descarte Pneus": "Descarte Pneus",
    "Deseja enviar para TicketLog a OS": "Deseja enviar para TicketLog a OS",
    "Digite para pesquisar": "Digite para pesquisar",
    "Enviar": "Enviar",
    "Equipamento Liberado": "Equipamento Liberado",
    "Escreva seu script aqui": "Escreva seu script aqui",
    "Informar Sinistro": "Informar Sinistro",
    "Informe o KM do Pneu": "Informe o KM do Pneu",
    "Informe o serviço feito!": "Informe o serviço feito!",
    "Insira o KM do veículo:": "Insira o KM do veículo:",
    "Insira os Serviços": "Insira os Serviços",
    "Inventário de estoque": "Inventário de estoque",
    "Inverter pneus": "Inverter pneus",
    "Início Atendimento OS": "Início Atendimento OS",
    "Item": "Item",
    "Itens:": "Itens:",
    "KM": "KM",
    "KM PROX.": "KM PROX.",
    "Lançamento de item": "Lançamento de item",
    "Lista": "Lista",
    "MODELO": "MODELO",
    "Matrícula": "Matrícula",
    "Motivo": "Motivo",
    "NR Fogo": "NR Fogo",
    "OS Preventiva Vencida": "OS Preventiva Vencida",
    "Observacao": "Observação",
    "PROX. CICLO": "PROX. CICLO",
    "Para qual fornecedor você deseja enviar esta OS?": "Para qual fornecedor você deseja enviar esta OS?",
    "Pesquisa global": "Pesquisa global",
    "Pesquisar": "Pesquisar",
    "Pesquisar Item": "Pesquisar Item",
    "Pesquisar peça": "Pesquisar peça",
    "Pesquisar serviço": "Pesquisar serviço",
    "Planos": "Planos",
    "Pneus a Placa:": "Pneus a Placa:",
    "Próximo Ciclo": "Próximo Ciclo",
    "Pular": "Pular",
    "Selecione a empresa": "Selecione a empresa",
    "Selecione um fornecedor": "Selecione um fornecedor",
    "Selecione um motivo": "Selecione um motivo",
    "Servicos": "Serviços",
    "Sinalizar Sinistro": "Sinalizar Sinistro",
    "Status": "Status",
    "Sucesso!": "Sucesso!",
    "Vencimento": "Vencimento",

    // Mensagens de validação
    "Preenchimento obrigatório": "Preenchimento obrigatório",
    "Disponível": "Disponível",
    "Deve ser maior que 0": "Deve ser maior que 0",
    "Não pode ser negativo": "Não pode ser negativo",
    "Valor Unitário": "Valor Unitário",
    "Existem filtros salvos e aplicados": "Existem filtros salvos e aplicados",

    "Adicionar Arquivos": "Adicionar Arquivos",
    "Ordem de Serviço criada com Sucesso": "Ordem de Serviço criada com Sucesso",
    "Falha ao parar execução. Tente novamente": "Falha ao parar execução. Tente novamente",
    "Selecionar": "Selecionar",

"Insira todas as informações": "Insira todas as informações",
"Item registrado com sucesso": "Item registrado com sucesso",
"Insira um preço": "Insira um preço",
"OS Preventiva A Vencer": "OS Preventiva A Vencer",
"OS já está aberta": "OS já está aberta",
"Não trabalhando": "Não trabalhando",
"ABASTECIMENTO": "ABASTECIMENTO",
"CHECKLIST": "CHECKLIST",
"CHECKLIST CONFORMIDADE": "CHECKLIST CONFORMIDADE",
"PREVENTIVA CARROCERIA": "PREVENTIVA CARROCERIA",
"SOCORRO EM ROTA": "SOCORRO EM ROTA",
"finalizado": "finalizado",
"contagem": "contagem",
"contagem_de_itens": "Contagem de Itens",
"codigo": "Código",
"saldo_atual": "Saldo Atual",
"item_nao_registrado_tente_novamente": "Item não registrado, tente novamente",
"versao": "Versão",
"informe_a_leitura_de_todos_os_sulcos": "Informe a leitura de todos os sulcos",
"Faça a leitura de todos os pneus para registrar": "Faça a leitura de todos os pneus para registrar",
"Leitura registrada com sucesso": "Leitura registrada com sucesso",

}
